import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';

dayjs.extend(utc);
dayjs.extend(timezone);

const getCurrentTimeZone = date => {
  //  utc(true) - означает что date уже в utc формате
  return date.utc(true).tz('America/Argentina/Buenos_Aires'); // UTC -03:00
};

export default getCurrentTimeZone;
